import { Outlet } from "react-router-dom";
import { ShopHeader } from "@/components/shop/ShopHeader";
import { AppDownloadBanner } from "@/components/shop/AppDownloadBanner";
import { AppDownloadFAB } from "@/components/shop/AppDownloadFAB";
import { Footer } from "@/components/landing/Footer";

export const ShopLayout = () => (
  <div className="min-h-screen bg-[#FBFAF6] flex flex-col">
    <AppDownloadBanner />
    <ShopHeader />
    <main className="flex-1">
      <Outlet />
    </main>
    <AppDownloadFAB />
    <Footer />
  </div>
);
